module.exports = __webpack_public_path__ + "static/media/competitionTask.b78592fa.pdf";